import React, {Component} from 'react';
import { hashHistory } from 'react-router';
import ReactGA from 'react-ga';
import data from '../../content/checklistContent.js';
import './Checklist.css';

ReactGA.initialize('UA-76692344-1');

export default class Checklist extends Component {

    constructor() {
        super();
        this.state = {
            checks: (new Array(data.points.length+2/*income and cash flow statements*/)).fill(false),
            checkCount: 0,
            show: (new Array(data.points.length+2/*income and cash flow statements*/)).fill(false)
        };
        // this.state.checks[3] = true; // Mock data
        // this.state.checks[5] = true; // Mock data
    }

    // Handles when user checks a checkbox
    _handleCheck = (pointId) => {
        let checks = this.state.checks;
        checks[pointId] = !checks[pointId]; // Toggle the checkbox boolean value
        this.setState({
            checks: checks,
            checkCount: checks.filter(Boolean).length // Update the check count
        })
    }

    // Redirects to Success page if all checkboxes are checked
   componentDidUpdate() {
        // /*TRACKER*/ console.log(this.state.checkCount, 'checked')
        // if (this.state.checkCount === this.state.checks.length) {
        //     hashHistory.push('success');
        // }
    }

    _handleDone = () => {
        hashHistory.push('success');
        this.props.rerender();
    }

    // Handles when user expands/collapses a check point content
    _handleToggleDisplay = (pointId) => {
        let show = this.state.show;
        show[pointId] = !show[pointId];
        this.setState({
            show: show
        })
    }

    // Google Analytics tracker for the template download buttons
    _handleDownload = (label) => {
        ReactGA.ga('send', 'event', { eventCategory: 'download', eventAction: 'download', eventLabel: label});
    }

    render() {
        return (
            <div className='page-container'>
                <div className='count'>
                    { this.state.checkCount === this.state.checks.length ?
                    <button onClick={this._handleDone}>ALL DONE</button>
                    : <p>{this.state.checkCount} of {this.state.checks.length}</p> }
                </div>
                <div className='progress'>
                    {this.state.checks.map((check,idx)=>{
                        // /*TRACKER*/ console.log('map')
                        if (check) {
                            // /*TRACKER*/ console.log('true')
                            return (
                                <div key={idx} className='progress-block'></div>
                            )
                        } else {
                        // /*TRACKER*/ console.log('false')
                            return null;
                        }
                    })}
                </div>
                <br/>
                <h1 className="checklist title">
                    {data.title}
                </h1>
                <span style={{paddingLeft: '5vw', paddingRight: '5vw'}}> Check these metrics to stay on top of your financial health </span>
                <ul className='points'>
                    {data.points.map((point,idx)=>( // For each point of the checklist, print it out with a checkbox
                        <li key={point.subtitle}>
                            <div className='subpoint-title'>
                                <div className='left'>
                                    <input onClick={ () => {this._handleCheck(idx)} } id={point.subtitle} type='checkbox' className='checkbox'/>
                                    <label htmlFor={point.subtitle}>{point.subtitle}</label>
                                </div>
                                <div
                                    className={ this.state.show[idx] ?
                                    'right collapse-title is-active'
                                    :'right collapse-title' }
                                    onClick={ () => this._handleToggleDisplay(idx) }
                                >
                                    <span className="icon">
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        <i className="fa fa-chevron-up" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <div
                                className={ this.state.show[idx] ?
                                    'collapse-content is-active'
                                    :'collapse-content'
                                }
                            >
                                <ul className='subpoints'>
                                    {point.subpoints.map(subpoint=>( // For each subpoint of the check points, print it out
                                        <li className='subpoint' key={Math.random()}>
                                            { subpoint.texts ?
                                            <span dangerouslySetInnerHTML={{__html: subpoint.texts[0]}}></span>
                                            : null}
                                            {/*subpoint.links ? // Are there links?
                                                subpoint.links.map((link,idx)=>( // For each link, print the link and the text after it
                                                    <span key={idx}>
                                                        <a href={link.link} className='link'>{link.text}</a>
                                                        <span dangerouslySetInnerHTML={{__html: subpoint.texts[idx+1]}}></span>
                                                    </span>)
                                                )
                                            : null*/
                                            // In-line links have been moved to the bottom as LEARN MORE buttons
                                            }
                                            {subpoint.equation ? // Is there an equation?
                                                <span className='equation'>
                                                    <div style={{textAlign: 'left', color: '#096499', fontWeight: '600'}}>
                                                        How to Calculate:
                                                    </div>
                                                    <div className='formula'>
                                                        {subpoint.equation.num ? // Is there a fractionpm starn?
                                                            <div className='fraction'>
                                                                <div className='numerator'>
                                                                    {subpoint.equation.num}
                                                                </div>
                                                                <div className='denominator'>
                                                                    {subpoint.equation.denom}
                                                                </div>
                                                            </div>
                                                        : null}
                                                        {subpoint.equation.int ? // Is there an undivided variable?
                                                            <div className='whole'>
                                                                {subpoint.equation.int}
                                                            </div>
                                                        : null}
                                                    </div>
                                                </span>
                                            : null}
                                        </li>)
                                    )}
                                    {point.subpoints.map(subpoint=>(
                                        <div key={Math.random()}>
                                            {subpoint.links ?
                                                (<a href={subpoint.links[0].link} className='link' target='_blank'>
                                                    <button>{/*subpoint.links[0].text*/}LEARN MORE</button>
                                                </a>)
                                                : null}
                                        </div>
                                    ))}
                                </ul>
                            </div>
                            {/* <p className='separator'>...</p> */
                            // Removed this and made check point content collapsible
                            }
                        </li>)
                    )}
                </ul>
                <div className='income-statement'>
                    <h1 className="title">
                        What is an Income Statement?
                    </h1>
                    <p className='description'>
                        Understanding your revenues and expenses you can figure out where you are doing well and where you can improve
                    </p>
                    <div className='collapsible-box'>
                        <div className='subpoint-title income-statement-collapsible'>
                            <div className='left'>
                                <input onClick={ () => {this._handleCheck(data.points.length)} } id='income-statement' type='checkbox' className='checkbox'/>
                                <label htmlFor='income-statement'>Fill out Income Statement</label>
                            </div>
                            <div
                                className={ this.state.show[data.points.length] ?
                                'right collapse-title is-active'
                                :'right collapse-title' }
                                onClick={ () => this._handleToggleDisplay(data.points.length) }
                            >
                                <span className="icon">
                                    <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    <i className="fa fa-chevron-up" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <div
                            className={ this.state.show[data.points.length] ?
                                'collapse-content is-active'
                                :'collapse-content'
                            }
                        >
                            <ul className='income-equation'>
                                <li>
                                    <div className='arith'></div><div><strong>Revenues:</strong> How much money are you making?</div>
                                </li>
                                <li>
                                    <div className='arith'>-</div><div><strong>Cost of Sales or Cost of Goods Sold:</strong> How much does it cost to make your products?</div>
                                </li>
                                <li>
                                    <div className='arith'>-</div><div><strong>Selling, General, and Administrative (SG&A):</strong> How much does it cost to run your company (e.g., rent, phone lines, internet connection)?</div>
                                </li>
                                <li>
                                    <div className='arith'>-</div><div><strong>Depreciation / Amortization:</strong> How much are you depreciating your assets by each period?</div>
                                </li>
                                <li>
                                    <div className='arith'>-</div><div><strong>Other Operating Expenses:</strong> How much were your other expenses in your operations?</div>
                                </li>
                                <li>
                                    <div className='arith'>-</div><div><strong>Interest Expense / Interest Income:</strong> How much do you pay in interest?</div>
                                </li>
                                <li className='numerator' style={{borderColor: 'black'}}>
                                    <div className='arith'>-</div><div><strong>Income Taxes:</strong> How much did you pay in taxes?</div>
                                </li>
                                <li>
                                    <div className='arith'>=</div><div><strong>Net income:</strong> How much profit (loss) did you make this year?</div>
                                </li>
                            </ul>
                            <p className='sublist'>
                                We made you an income statement to save you the hassle! We’ve even included some of the metrics listed above. 😉
                            </p>
                            <div className='download-button'>
                                <a href='files/Income_Statement_Template.xlsx' download>
                                    <button
                                        onClick={ () => this._handleDownload('DOWNLOAD INCOME STATEMENT')}
                                        type='submit'
                                    >
                                        DOWNLOAD INCOME STATEMENT
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='cash-flow-statement'>
                    <h1 className="title">
                        What is a Cash Flow Statement?
                    </h1>
                    <p className='description'>
                        The cash flow statement tells you how much money is entering and leaving your business
                    </p>
                    <div className='collapsible-box'>
                        <div className='subpoint-title cash-flow-statement-collapsible'>
                            <div className='left'>
                                <input onClick={ () => {this._handleCheck(data.points.length+1)} } id='income-statement' type='checkbox' className='checkbox'/>
                                <label htmlFor='income-statement'>Fill out Cash Flow Statement</label>
                            </div>
                            <div
                                className={ this.state.show[data.points.length+1] ?
                                'right collapse-title is-active'
                                :'right collapse-title' }
                                onClick={ () => this._handleToggleDisplay(data.points.length+1) }
                            >
                                <span className="icon">
                                    <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    <i className="fa fa-chevron-up" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <div
                            className={ this.state.show[data.points.length+1] ?
                                'collapse-content is-active'
                                :'collapse-content'
                            }
                        >
                            <ol type="1">
                                <li>
                                    <strong>Cash flow from operations:</strong> This metric refers to cash generated through the principal operations of your business.
                                </li>
                                <li>
                                    <strong>Cash flow from investing:</strong> This metric refers to cash spent on capital investments required to make your business run
                                </li>
                                <li>
                                    <strong>Cash flow from financing:</strong> Deals with cash made or paid back from financing
                                </li>
                            </ol>
                            <p className='sublist'>
                                We think creating a cash flow statement requires a lot of time and expertise, so we’ve made one for you to save you the hassle! 🙂
                            </p>
                            <div className='download-button'>
                                <a href='files/Cash_Flow_Statement_Template.xlsx' download>
                                    <button
                                        onClick={ () => this._handleDownload('DOWNLOAD CASH FLOW STATEMENT')}
                                        type='submit'
                                    >
                                        DOWNLOAD CASH FLOW STATEMENT
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// src/components/pages/Checklist.js